import React from "react";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import profileActions from "../../../../Profile/redux/actions";
import { withFirebase } from "../../../../../common/auth/firebase";

const LogoutButton = ({ firebase }) => {
  const dispatch = useDispatch();
  const handleSignOut = () => {
    firebase.doSignOut();
    dispatch(profileActions.updateProfileSuccess(null));
  };
  return (
    <>
      <h5
        style={{
          fontSize: "1.25rem",
          color: "#447ce9",
          textDecoration: "underline",
        }}
        onClick={() => {
          handleSignOut();
        }}
      >
        Log out
      </h5>
    </>
  );
};
export default withFirebase(LogoutButton);
